import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngxs/store';
import { first } from 'rxjs/operators';
import { GrowlService } from '../../service/growl.service';
import { LanguageService } from '../../service/language.service';
import { RouterAction } from '../../store/router.action';

@Component({
    selector: 'app-language',
    template: '<div class="page-content"></div>',
})
export class LanguageComponent {

    constructor(languageService: LanguageService,
                growlService: GrowlService,
                route: ActivatedRoute,
                store: Store) {
        route.params
            .pipe(first())
            .subscribe(params => {
                const lang = params.language;
                const languageSet = languageService.use(lang);
                store.dispatch(new RouterAction.Navigate(['/']));
                if (languageSet) {
                    growlService.showInfoGrowl('GROWL.LANGUAGE_SET', {lang});
                } else {
                    growlService.showErrorGrowl('GROWL.LANGUAGE_NOT_SET', {lang});
                }
            });
    }
}
